[
  {
    "id": "services",
    "path": "/10.html",
    "kind": "hub",
    "navLabel": "All Services",
    "eyebrow": "Commercial vehicles, clear repair choices",
    "title": "Truck Bodywork Services | Motor City Truck Collision",
    "description": "Explore truck, fleet, trailer, RV and equipment bodywork, painting and graphics at Motor City Truck Collision in Brighton, Michigan.",
    "h1": "Find the Right Service for Your Vehicle",
    "intro": "Start with the part of the vehicle that needs work. Motor City Truck Collision in Brighton handles commercial bodywork and refinishing, with focused pages for truck bodies, fleets, trailers, RV exteriors, paint and related services.",
    "answer": {
      "question": "Which page fits my repair or painting project?",
      "text": "Choose the vehicle type for general bodywork, or a focused roof, wall, floor, door or service-body page for a specific component. For painting without collision damage, start with commercial truck painting. The quote form also accepts painting-only inquiries."
    },
    "sections": [
      {
        "heading": "A clear scope makes the first conversation useful",
        "paragraphs": [
          "Tell the shop the vehicle type, the affected surfaces and the result you want. Photos can help show damage or paint condition, but they are optional. Include the fleet number, color standard and preferred timing when relevant."
        ]
      },
      {
        "heading": "Bodywork and mechanical work are different",
        "paragraphs": [
          "Identify engine, drivetrain, trailer running-gear or RV interior concerns separately, and ask the shop which service contact is appropriate."
        ]
      }
    ],
    "checklist": {
      "heading": "Start with three details",
      "items": [
        "The vehicle or equipment you have",
        "The bodywork, paint or finish you want",
        "Any photos, unit information or timing requirements you can supply"
      ]
    },
    "faqs": [
      {
        "question": "Can one request include bodywork and painting?",
        "answer": "Yes. Describe both the damaged surfaces and the desired finish so the scope can be discussed together."
      },
      {
        "question": "What if I am unsure which service I need?",
        "answer": "Call 248-986-8000 and describe the vehicle and the problem. The Brighton shop can help direct the inquiry."
      }
    ],
    "related": [],
    "links": [
      {
        "href": "/Semi-Truck-Body-Shop",
        "label": "Semi truck body repair",
        "description": "Cabs, hoods, bumpers and refinishing"
      },
      {
        "href": "/box-truck-repair.html",
        "label": "Box truck repair",
        "description": "Cargo roofs, walls, floors and doors"
      },
      {
        "href": "/Ford-Body-Shop-Collision-Repair-and-Paint-Shop",
        "label": "Ford truck body repair",
        "description": "Cab and work-body repairs, painting and refinishing"
      },
      {
        "href": "/Isuzu-Repair",
        "label": "Isuzu truck body repair",
        "description": "NPR/NQR cabs, cargo-box repairs and painting"
      },
      {
        "href": "/Fleet-Truck-Body-Repair",
        "label": "Fleet body and frame repair",
        "description": "Unit scope, structural assessment and fleet colors"
      },
      {
        "href": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial truck painting",
        "description": "Panel blends, repainting and color matching"
      },
      {
        "href": "/Service-Body-Repair",
        "label": "Service and utility bodies",
        "description": "Compartments, doors and body damage"
      },
      {
        "href": "/26.html",
        "label": "Trailer and RV bodywork",
        "description": "Choose the right exterior repair page"
      },
      {
        "href": "/CommercialVehicleGraphicWraps.html",
        "label": "Graphics and wraps",
        "description": "Company lettering and vinyl coverage"
      },
      {
        "href": "/earthmoving-equipment-restoration-paint-repair.html",
        "label": "Equipment restoration",
        "description": "Bodywork, preparation and painting"
      },
      {
        "href": "/dustless-sandblasting.html",
        "label": "Sandblasting",
        "description": "Project-specific preparation and finishing"
      },
      {
        "href": "/car-truck-detailing.html",
        "label": "Car and truck detailing",
        "description": "Interior and exterior cleaning"
      },
      {
        "href": "/repair-guides",
        "label": "Repair and maintenance guides",
        "description": "Practical answers before you request work"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/",
      "https://www.motorcitytruckcollision.com/10.html"
    ],
    "preservedFacts": [
      "Old numeric URL retained and improved as service chooser",
      "Existing verified service families"
    ]
  },
  {
    "id": "trailer-rv-overview",
    "path": "/26.html",
    "kind": "hub",
    "navLabel": "Trailer & RV Bodywork",
    "eyebrow": "Choose the exterior work you need",
    "title": "Trailer & RV Bodywork Services | Motor City Truck Collision",
    "description": "Find trailer, enclosed cargo, RV exterior and floor-lining information at Motor City Truck Collision in Brighton, Michigan.",
    "h1": "Trailer & RV Bodywork",
    "intro": "Trailer and RV projects can involve very different work. Use these pages to identify exterior body repair, roof damage, cargo enclosure problems or a floor project before contacting the Brighton shop.",
    "answer": {
      "question": "Where should I start for trailer or RV service?",
      "text": "Choose trailer body repair for exterior skin, roof, wall and door damage, or RV body repair for motorhome and RV exterior concerns. Use the guides for broader maintenance planning, and identify mechanical or interior-system needs separately."
    },
    "sections": [
      {
        "heading": "Describe the body and the use of the unit",
        "paragraphs": [
          "Include the manufacturer, model, size and type of trailer or RV. Wide photos show the damaged area’s location; close photos and any known leaks help describe the project."
        ]
      },
      {
        "heading": "Keep body and mechanical inquiries clear",
        "paragraphs": [
          "Bodywork and painting do not automatically include brakes, axles, appliances or interior systems. Ask the appropriate provider about those services. Motor City Trailer Repair is the existing destination for trailer mechanical inquiries."
        ]
      }
    ],
    "faqs": [
      {
        "question": "Can roof and sidewall damage be one inquiry?",
        "answer": "Yes. Describe the connected areas, any water entry and the surrounding openings so the assessment considers the full exterior project."
      },
      {
        "question": "Does a coating fix a damaged trailer floor?",
        "answer": "No. Damaged flooring needs assessment before lining or coating is discussed. A coating is not a structural floor repair."
      }
    ],
    "links": [
      {
        "href": "/Trailer-Repair",
        "label": "Trailer body repair",
        "description": "Exterior panels, roof, doors and related structure"
      },
      {
        "href": "/Enclosed-Trailer-Repair",
        "label": "Enclosed trailer repair",
        "description": "Cargo walls, roofs, doors and bodywork"
      },
      {
        "href": "/RV-Repair",
        "label": "RV exterior and roof repair",
        "description": "Fiberglass, sidewalls, roof openings and paint"
      },
      {
        "href": "/RhinoLiningYourHorseTrailer.html",
        "label": "Horse trailer floor lining",
        "description": "Sound flooring before coating"
      },
      {
        "href": "/Landscaping-Trailer-Repair-and-Maintenance",
        "label": "Landscaping trailer guide",
        "description": "Plan body and maintenance inquiries"
      },
      {
        "href": "/Complete-RV-Trailer-Repair-Maintenance",
        "label": "RV trailer service guide",
        "description": "Separate exterior and system-service needs"
      },
      {
        "href": "https://www.motorcitytrailerrepair.com/",
        "label": "Motor City Trailer Repair",
        "description": "Confirm current mechanical trailer services"
      }
    ],
    "related": [
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Painting and refinishing"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/26.html",
      "https://www.motorcitytruckcollision.com/Trailer-Repair",
      "https://www.motorcitytruckcollision.com/RV-Repair"
    ],
    "preservedFacts": [
      "Numeric trailer hub URL retained",
      "Trailer/RV/body/mechanical distinctions"
    ]
  },
  {
    "id": "shop-overview",
    "path": "/34.html",
    "kind": "about",
    "navLabel": "About the Shop",
    "eyebrow": "Brighton, Southeast Michigan",
    "title": "About the Brighton Shop | Motor City Truck Collision",
    "description": "Meet Motor City Truck Collision’s commercial bodywork and paint services in Brighton, part of the Garrett Auto & Truck Service family.",
    "h1": "A Body Shop for Working Vehicles",
    "intro": "Motor City Truck Collision is based at 12264 Emerson Dr. in Brighton, Michigan. The shop focuses on commercial truck, fleet, trailer and RV bodywork, along with painting and related exterior services.",
    "answer": {
      "question": "How is Motor City Truck Collision connected to Garrett?",
      "text": "Motor City Truck Collision is part of the Garrett Auto & Truck Service family. Garrett has served Southeast Michigan since 1958."
    },
    "sections": [
      {
        "heading": "The vehicle and the work come first",
        "paragraphs": [
          "A semi cab, cargo box and utility body have different construction and finish needs. The service pages explain those differences so you can bring the shop a useful description of the work.",
          "The repair discussion starts with the vehicle, damage or paint condition, and the result you want. Unit details, photos, fleet colors and preferred timing help establish the scope."
        ]
      },
      {
        "heading": "Part of the Garrett service family",
        "paragraphs": [
          "Garrett Auto & Truck Service provides the family connection and its long history in Southeast Michigan. Visit Garrett’s website for that business’s services and credentials.",
          "Motor City’s bodywork pages keep the scope clear for this shop. Mechanical, drivetrain, trailer running-gear and RV interior-system questions should be routed to the appropriate provider."
        ]
      }
    ],
    "checklist": {
      "heading": "Contact the Brighton shop",
      "items": [
        "Motor City Truck Collision",
        "12264 Emerson Dr., Brighton, MI 48116",
        "248-986-8000"
      ]
    },
    "faqs": [
      {
        "question": "Where is the shop?",
        "answer": "Motor City Truck Collision is at 12264 Emerson Dr., Brighton, Michigan 48116."
      },
      {
        "question": "Can I request paint without a collision repair?",
        "answer": "Yes. Describe the vehicle, surfaces and desired finish in a quote request or call the shop."
      }
    ],
    "links": [
      {
        "href": "https://www.garrettauto.com/",
        "label": "Garrett Auto & Truck Service",
        "description": "Explore the Garrett family’s services"
      },
      {
        "href": "/A-Superior-Body-Shop",
        "label": "Our bodywork approach",
        "description": "Assessment, preparation and finish planning"
      }
    ],
    "related": [
      {
        "path": "/10.html",
        "label": "Browse services"
      },
      {
        "path": "/contact-motor-city-truck-collision.html",
        "label": "Contact the shop"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/",
      "https://www.motorcitytruckcollision.com/34.html",
      "https://www.garrettauto.com/"
    ],
    "preservedFacts": [
      "Garrett heritage attributed correctly",
      "Verified name/address/phone",
      "Old logo-only URL given meaningful shop information"
    ]
  },
  {
    "id": "work-gallery",
    "path": "/ourrepairwork.html",
    "kind": "gallery",
    "navLabel": "Our Work",
    "eyebrow": "See the work",
    "title": "Truck Bodywork Photos | Motor City Truck Collision",
    "description": "See real shop photos of commercial truck bodywork and painting from Motor City Truck Collision in Brighton, Michigan.",
    "h1": "Quality Work. Professional Finish.",
    "intro": "Explore shop photos showing commercial bodywork and paint projects. The images help show the kinds of vehicles and body areas involved; the right repair for your own unit starts with its condition and the work you need.",
    "answer": {
      "question": "Can I request work similar to a gallery example?",
      "text": "Yes. Tell the shop the vehicle type and the bodywork, painting or restoration you have in mind. Your own photos and unit details are more useful for assessment than assuming a gallery image represents the same repair scope."
    },
    "sections": [
      {
        "heading": "From exterior panels to cargo bodies",
        "paragraphs": [
          "These shop photos show commercial vehicles and the body areas involved in the work. Use them to start a conversation about the condition and finish of your own vehicle."
        ]
      }
    ],
    "faqs": [
      {
        "question": "Are these pictures of actual shop work?",
        "answer": "The gallery uses imagery from Motor City Truck Collision’s existing shop gallery."
      },
      {
        "question": "Can I send photos of my own unit?",
        "answer": "Yes. Optional photos can help show the vehicle and affected body areas when discussing a quote."
      }
    ],
    "related": [
      {
        "path": "/Semi-Truck-Body-Shop",
        "label": "Semi bodywork"
      },
      {
        "path": "/box-truck-repair.html",
        "label": "Box truck repairs"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial painting"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/ourrepairwork.html"
    ],
    "preservedFacts": [
      "Actual shop gallery imagery",
      "No fabricated project histories or outcomes"
    ]
  },
  {
    "id": "contact",
    "path": "/contact-motor-city-truck-collision.html",
    "kind": "contact",
    "navLabel": "Contact",
    "eyebrow": "Talk with the Brighton shop",
    "title": "Contact Motor City Truck Collision | Brighton, MI",
    "description": "Call Motor City Truck Collision at 248-986-8000 or find the shop at 12264 Emerson Dr., Brighton, Michigan 48116.",
    "h1": "Contact Motor City Truck Collision",
    "intro": "Call the shop about commercial truck, fleet, trailer or RV bodywork, painting and related exterior projects. A clear description of your unit and the work needed helps start the conversation.",
    "answer": {
      "question": "How can I contact the shop?",
      "text": "Motor City Truck Collision is at 12264 Emerson Dr., Brighton, MI 48116. Call 248-986-8000 to discuss the vehicle and work. For bodywork or painting inquiries, visit the quote page."
    },
    "sections": [
      {
        "heading": "Have the basic details ready",
        "paragraphs": [
          "Describe the vehicle or equipment, the affected areas and the result you want. Include fleet colors, unit information or your preferred timing when those details matter.",
          "Photos are optional and can help show body damage or paint condition. Call to confirm current hours, assessment arrangements and any transport questions."
        ]
      }
    ],
    "faqs": [
      {
        "question": "What is the phone number?",
        "answer": "248-986-8000."
      },
      {
        "question": "Where is Motor City Truck Collision?",
        "answer": "12264 Emerson Dr., Brighton, Michigan 48116."
      },
      {
        "question": "Should I use the quote page for painting?",
        "answer": "Yes. The quote page includes commercial painting as a service choice, even when no collision repair is needed."
      }
    ],
    "links": [
      {
        "href": "tel:+12489868000",
        "label": "Call 248-986-8000"
      },
      {
        "href": "https://www.google.com/maps/search/?api=1&query=12264%20Emerson%20Dr.%2C%20Brighton%2C%20MI%2048116",
        "label": "Get directions"
      },
      {
        "href": "/request-a-quote.html",
        "label": "Request a Quote"
      }
    ],
    "related": [
      {
        "path": "/10.html",
        "label": "Find the service you need"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/contact-motor-city-truck-collision.html"
    ],
    "preservedFacts": [
      "Published phone/address",
      "No invented shop hours or visit promise"
    ]
  },
  {
    "id": "careers",
    "path": "/Body-Shop-Jobs",
    "kind": "careers",
    "navLabel": "Careers",
    "eyebrow": "Commercial bodywork and refinishing",
    "title": "Body Shop Careers | Motor City Truck Collision",
    "description": "Interested in truck bodywork or refinishing at Motor City Truck Collision in Brighton? Contact the shop about current roles and requirements.",
    "h1": "Body Shop Careers",
    "intro": "Interested in commercial vehicle bodywork or refinishing? Contact Motor City Truck Collision’s Brighton shop to ask about current opportunities and the experience needed for available roles.",
    "answer": {
      "question": "How do I learn about current body-shop opportunities?",
      "text": "Contact Kevin Brown at 248-417-9910 or use the live employment-information page linked on this page. Ask about current openings, role requirements and how to provide your experience or application details."
    },
    "sections": [
      {
        "heading": "Tell the shop about your experience",
        "paragraphs": [
          "Describe your background in body repair, panel work, surface preparation, refinishing or related commercial-vehicle work. Be specific about the types of vehicles and projects you have worked on."
        ]
      },
      {
        "heading": "Confirm the details of the role",
        "paragraphs": [
          "Ask about the responsibilities, schedule, application process and terms of any current opening. Compensation and benefits should be confirmed with the shop rather than assumed from an older listing."
        ]
      }
    ],
    "faqs": [
      {
        "question": "How do I check current openings?",
        "answer": "Contact Kevin Brown at 248-417-9910 to discuss current vacancies, role requirements and the application process."
      },
      {
        "question": "Where can I find the current application instructions?",
        "answer": "Ask the shop or visit its live employment-information page. This client preview does not accept or send applications."
      }
    ],
    "links": [
      {
        "href": "tel:+12484179910",
        "label": "Contact Kevin Brown: 248-417-9910"
      },
      {
        "href": "https://www.motorcitytruckcollision.com/Body-Shop-Jobs",
        "label": "View live employment information"
      }
    ],
    "related": [
      {
        "path": "/34.html",
        "label": "About the shop"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Body-Shop-Jobs"
    ],
    "preservedFacts": [
      "Existing recruiting purpose retained",
      "No unconfirmed current pay/benefit/vacancy promises"
    ]
  },
  {
    "id": "privacy",
    "path": "/privacy-policy",
    "kind": "privacy",
    "navLabel": "Privacy Policy",
    "eyebrow": "Privacy and SMS information",
    "title": "Privacy Policy | Motor City Truck Collision",
    "description": "Find Motor City Truck Collision’s published privacy policy, SMS choices and privacy contact information.",
    "h1": "Privacy Policy",
    "intro": "Use the published policy for the live website’s privacy and SMS terms. The linked policy explains the information collected through contact and SMS communications, its use and sharing, and the choices available to you.",
    "answer": {
      "question": "Where can I read the current privacy policy?",
      "text": "The current policy is published on Motor City Truck Collision’s live website. It includes SMS opt-out and help instructions and the business’s privacy contact information."
    },
    "sections": [
      {
        "heading": "SMS choices in the published policy",
        "paragraphs": [
          "The live policy states that you can reply STOP to opt out of SMS communications or text HELP for assistance. Read the policy itself for the complete terms."
        ]
      },
      {
        "heading": "Privacy questions",
        "paragraphs": [
          "The published privacy contact is sales@motorcitytruckcollision.com or 248-986-8000. Refer to the live policy for its full mailing address and disclosures."
        ]
      },
      {
        "heading": "Client preview",
        "paragraphs": [
          "The quote form in this preview does not send requests or files. Use the live website and its published terms when communicating with the actual shop."
        ]
      }
    ],
    "links": [
      {
        "href": "https://www.motorcitytruckcollision.com/privacy-policy",
        "label": "Read the current published policy"
      },
      {
        "href": "mailto:sales@motorcitytruckcollision.com",
        "label": "Email a privacy question"
      }
    ],
    "faqs": [
      {
        "question": "Does the preview form send my request to the shop?",
        "answer": "No. Its form flow is a client demonstration and does not send requests or files."
      }
    ],
    "related": [
      {
        "path": "/contact-motor-city-truck-collision.html",
        "label": "Contact information"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/privacy-policy"
    ],
    "preservedFacts": [
      "Existing policy kept as authoritative legal document",
      "SMS STOP/HELP and privacy contact",
      "No new legal promises authored"
    ]
  },
  {
    "id": "payment",
    "path": "/18.html",
    "kind": "payment",
    "navLabel": "Make a Payment",
    "eyebrow": "Existing customer payments",
    "title": "Customer Payment Information | Motor City Truck Collision",
    "description": "Use Motor City Truck Collision’s existing payment page or contact the shop with questions about your invoice.",
    "h1": "Customer Payment Information",
    "intro": "For an existing invoice, use the live payment page or contact the shop with a payment question. This client preview does not collect payment details or process a transaction.",
    "answer": {
      "question": "Where do I make a payment?",
      "text": "Open the existing Motor City Truck Collision payment page using the link on this page. Have the invoice information requested by that live process available. For payment assistance, call 248-640-4303."
    },
    "sections": [
      {
        "heading": "Keep invoice questions separate from a new quote",
        "paragraphs": [
          "If you have a question about an existing invoice, identify the invoice and the vehicle or job involved when contacting the shop. For work that has not been quoted, start with the quote page instead."
        ]
      }
    ],
    "links": [
      {
        "href": "https://www.motorcitytruckcollision.com/18.html",
        "label": "Open the live payment page"
      },
      {
        "href": "tel:+12486404303",
        "label": "Payment questions: 248-640-4303"
      }
    ],
    "faqs": [
      {
        "question": "Can I pay through this preview?",
        "answer": "No. This preview links to the existing live process; it does not collect payment information or process payments."
      }
    ],
    "related": [
      {
        "path": "/contact-motor-city-truck-collision.html",
        "label": "Contact the shop"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/18.html",
      "https://www.motorcitytruckcollision.com/19.html"
    ],
    "preservedFacts": [
      "Native payment/login process retained externally",
      "No mock billing/credential transaction"
    ]
  },
  {
    "id": "quote-preview-complete",
    "path": "/request-a-quote-thank-you.html",
    "kind": "thank-you",
    "navLabel": "Quote Preview Complete",
    "eyebrow": "Client demonstration",
    "title": "Quote Form Preview | Motor City Truck Collision",
    "description": "Client preview of the Motor City Truck Collision quote confirmation. No request or files have been sent.",
    "h1": "Quote Form Preview Complete",
    "intro": "This is a client preview. No request or files have been sent to the shop.",
    "answer": {
      "question": "Has a quote request been submitted?",
      "text": "No. The prototype demonstrates the quote page and its confirmation flow. To contact the actual shop, call 248-986-8000 or use the live website."
    },
    "sections": [
      {
        "heading": "Review the request flow",
        "paragraphs": [
          "Return to the quote page to review service choices, optional attachments and validation."
        ]
      }
    ],
    "links": [
      {
        "href": "/request-a-quote.html",
        "label": "Review the quote page"
      },
      {
        "href": "/",
        "label": "Back to home"
      },
      {
        "href": "tel:+12489868000",
        "label": "Call the shop"
      }
    ],
    "faqs": [],
    "related": [],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/request-a-quote-thank-you.html"
    ],
    "preservedFacts": [
      "Purpose-matched confirmation URL retained",
      "Explicit no-send prototype confirmation"
    ]
  },
  {
    "id": "repair-guides",
    "path": "/repair-guides",
    "kind": "hub",
    "navLabel": "Repair Guides",
    "eyebrow": "Useful answers before you call",
    "title": "Truck, RV & Trailer Repair Guides | Motor City Truck Collision",
    "description": "Practical guides to bodywork, paint, cargo-body repairs, RV exteriors and trailer maintenance questions from Motor City Truck Collision.",
    "h1": "Repair Guides",
    "intro": "Use these guides to understand the work you may need, gather useful information and choose the right service page. They help you prepare for an assessment; they do not replace an inspection of your vehicle or equipment.",
    "answer": {
      "question": "Which repair guide should I read first?",
      "text": "Choose the guide for the body area or project involved. Isuzu and RV guides help organize exterior-repair questions; paint and blasting guides explain preparation and cost factors; trailer guides distinguish bodywork from broader maintenance."
    },
    "sections": [
      {
        "heading": "Turn the guide into a clear inquiry",
        "paragraphs": [
          "Identify your vehicle, the affected surfaces and the desired result. Use the guide’s checklist for the details to share, then contact the shop or request a quote for the actual work."
        ]
      }
    ],
    "links": [
      {
        "href": "/isuzu-box-truck-body-repair-guide",
        "label": "Isuzu box truck body repair",
        "description": "Separate cab, cargo box, roof and floor concerns"
      },
      {
        "href": "/rv-body-roof-repair-guide",
        "label": "RV body and roof repair",
        "description": "Describe exterior damage and water entry"
      },
      {
        "href": "/Identifying-Common-Paint-Defects",
        "label": "Understanding paint defects",
        "description": "Describe finish problems before refinishing"
      },
      {
        "href": "/PPG-Custom-Auto-Restoration-Guide",
        "label": "Restoration planning and PPG reference",
        "description": "Use current manufacturer technical guidance"
      },
      {
        "href": "/Rust-Prevention-How-You-Can-Slow-Down-Rust-On-Your-Vehicle",
        "label": "Corrosion and maintenance",
        "description": "Distinguish surface care from body repair"
      },
      {
        "href": "/Top-Trailer-Maintenance-Services-That-Must-Be-Done-Regularly",
        "label": "Trailer maintenance questions",
        "description": "Plan body and mechanical service inquiries"
      },
      {
        "href": "/Popular-RV-Travel-Trailers-in-Michigan",
        "label": "RV trailer types and repair planning",
        "description": "Consider type, use and exterior condition"
      },
      {
        "href": "/how-much-does-it-cost-to-sandblast.html",
        "label": "Sandblasting cost factors",
        "description": "Define preparation and finish scope"
      },
      {
        "href": "/Complete-RV-Trailer-Repair-Maintenance",
        "label": "Planning RV trailer service",
        "description": "Separate exterior work from interior systems"
      },
      {
        "href": "/Landscaping-Trailer-Repair-and-Maintenance",
        "label": "Landscaping trailer bodywork",
        "description": "Describe ramps, floors, openings and maintenance needs"
      },
      {
        "href": "/why-enclosed-trailers-get-wall-bowing",
        "label": "Enclosed Trailer Wall Bowing",
        "description": "Understand visible enclosed-trailer wall bowing, gaps and door changes. Organize the damage details for a professional body assessment in Brighton."
      },
      {
        "href": "/common-causes-of-box-truck-roof-leaks-and-how-to-fix-them",
        "label": "Box Truck Roof Leak Causes",
        "description": "Learn which box truck roof joints and damage details matter in a leak assessment. Motor City Truck Collision in Brighton reviews roof and related body damage."
      },
      {
        "href": "/how-to-spot-early-signs-of-structural-damage-on-commercial-trucks",
        "label": "Structural Damage: Visible Signs",
        "description": "Record panel gaps, damaged mounts, floor changes and other visible concerns after an impact. Arrange professional truck body and frame assessment in Brighton."
      },
      {
        "href": "/how-cross-members-get-damaged-in-truck-collisions",
        "label": "Truck Cross-Member Damage",
        "description": "Understand cross-member damage and the body changes to report after an impact. Request commercial frame and body assessment at Motor City Truck Collision."
      },
      {
        "href": "/how-to-inspect-a-trailer-tongue-after-impact",
        "label": "Trailer Tongue After an Impact",
        "description": "Record visible tongue, coupler and attachment changes after an impact. Confirm professional trailer inspection scope with the appropriate service provider."
      }
    ],
    "faqs": [
      {
        "question": "Do the guides provide a final repair price?",
        "answer": "No. The actual condition, materials, parts and agreed scope determine the quote. The guides help you gather information for that conversation."
      }
    ],
    "related": [
      {
        "path": "/10.html",
        "label": "Browse services"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/",
      "https://www.motorcitytruckcollision.com/isuzu-box-truck-body-repair-guide",
      "https://www.motorcitytruckcollision.com/rv-body-roof-repair-guide"
    ],
    "preservedFacts": [
      "New curated navigation hub has distinct reader value",
      "Existing guide URLs remain unchanged"
    ]
  }
]
